import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-default-menu',
  templateUrl: './public-default-menu.component.html',
})
export class PublicDefaultMenuComponent implements OnInit {

  /**
   * Constructor
   */
  public constructor() { }

  /**
   * Initialize the Component
   *
   * @return void
   */
  public ngOnInit(): void { }

}
